import React, { useState, useEffect } from 'react'
import PropTypes from 'prop-types'
import { useDispatch, useSelector } from 'react-redux'
import * as reducks from '../../../reducks'
import Modal from '../../commons/Modal/Modal'
import Text from '../../commons/Text/Text'
import Flex from '../../commons/Flex/Flex'
import Tag from '../../commons/Tag/Tag'
import Button from '../../commons/Button/Button'

export const handleChange = (value, current = [], setValue) => {
  const currentItemIntex = current.findIndex((item) => item === value.id)
  const currentItem = current[currentItemIntex]
  const newValue = [...current]

  if (value.status) {
    if (currentItem) return

    newValue.push(value.id)
  } else {
    if (!currentItem) return

    newValue.splice(currentItemIntex, 1)
  }

  setValue({ indicators: newValue })
}

export const handleSubmit = async (value, closeCallback, dispatch) => {
  await dispatch(
    reducks.resources.timeline.actions.receiveFiltersAndGetTimeline(value)
  )

  closeCallback()
}

const ModalMatriz = (props) => {
  const { visible, closeCallback } = props

  const dispatch = useDispatch()

  const filters = useSelector((state) => state?.timelineReducer?.filters)

  useEffect(() => {
    dispatch(reducks.resources.filters.actions.getPriorityMatrices())
  }, [])

  const [value, setValue] = useState({
    indicators: filters?.indicators
  })

  useEffect(() => {
    setValue({ indicators: filters?.indicators })
  }, [visible, filters?.indicators])

  const { priorityMatrices } = useSelector((state) => state.filtersReducer)

  return (
    <Modal
      visible={visible}
      size="small"
      rounded
      onClickOverlay={closeCallback}
      HeaderContent={() => (
        <>
          <Text
            value="Matriz de Prioridades"
            size="md"
            color="gray"
            variation="dark"
            bold
          />
        </>
      )}
    >
      <Flex wrap="wrap" margin="10px 0px">
        {priorityMatrices.content.map((tag) => {
          const isActive = value.indicators.includes(tag.id)
          const transformedTag = {
            id: tag.id,
            status: !isActive
          }

          return (
            <Tag
              onClick={() => {
                handleChange(transformedTag, value.indicators, setValue)
              }}
              key={tag.id}
              id={tag.id}
              active={isActive}
              text={tag.name}
              size="xxs"
            />
          )
        })}
      </Flex>

      <Flex alignItems="center" justifyContent="center" margin="10px 0px">
        <Button
          type="secondary"
          onClick={() => handleSubmit(value, closeCallback, dispatch)}
        >
          Ver resultado
        </Button>
      </Flex>
    </Modal>
  )
}

ModalMatriz.defaultProps = {
  visible: false,
  closeCallback: null
}

ModalMatriz.propTypes = {
  visible: PropTypes.bool,
  closeCallback: PropTypes.func
}

export default ModalMatriz
